import React, { useState } from 'react';
import axios from 'axios';
import '../styles/PointOfSaleForm.css';

const PointOfSaleForm = ({ onPointOfSaleAdded, onCancel, isFirstPointOfSale = true }) => {
  const [formData, setFormData] = useState({
    pos_name: '',
    pos_address: '',
    pos_phone: '',
    pos_city: '',
    pos_region: ''
  });
  
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const { pos_name, pos_address, pos_phone, pos_city, pos_region } = formData;

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate required fields
    if (!pos_name) {
      setError('El nombre del punto de venta es obligatorio');
      return;
    }

    try {
      setLoading(true);
      setError('');
      
      const token = localStorage.getItem('token');
      
      // Incluir el campo pos_type con el valor correspondiente en la solicitud
      // Si es el primer punto de venta, será 'matriz', si no, será 'adicional'
      const dataToSend = {
        ...formData,
        pos_type: isFirstPointOfSale ? 'matriz' : 'adicional' // Establecer el tipo de punto de venta según si es el primero o no
      };
      
      const response = await axios.post('/api/points-of-sale', dataToSend, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      
      setLoading(false);
      
      // Call the callback function to update the parent component
      if (onPointOfSaleAdded) {
        onPointOfSaleAdded(response.data);
      }
    } catch (error) {
      setLoading(false);
      
      if (error.response && error.response.data && error.response.data.error) {
        setError(error.response.data.error);
      } else {
        setError('Error al agregar el punto de venta. Por favor, inténtalo de nuevo.');
      }
      
      console.error('Error adding point of sale:', error);
    }
  };

  return (
    <div className="point-of-sale-form-container">
      <h3>Agregar Punto de Venta</h3>
      
      {error && <div className="error-message">{error}</div>}
      
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="pos_name">Nombre del Punto de Venta *</label>
          <input
            type="text"
            id="pos_name"
            name="pos_name"
            value={pos_name}
            onChange={handleChange}
            placeholder="Ingresa el nombre del punto de venta"
            required
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="pos_address">Dirección</label>
          <input
            type="text"
            id="pos_address"
            name="pos_address"
            value={pos_address}
            onChange={handleChange}
            placeholder="Ingresa la dirección (opcional)"
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="pos_phone">Teléfono</label>
          <input
            type="text"
            id="pos_phone"
            name="pos_phone"
            value={pos_phone}
            onChange={handleChange}
            placeholder="Ingresa el teléfono (opcional)"
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="pos_city">Ciudad</label>
          <input
            type="text"
            id="pos_city"
            name="pos_city"
            value={pos_city}
            onChange={handleChange}
            placeholder="Ingresa la ciudad (opcional)"
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="pos_region">Región</label>
          <input
            type="text"
            id="pos_region"
            name="pos_region"
            value={pos_region}
            onChange={handleChange}
            placeholder="Ingresa la región (opcional)"
          />
        </div>
        
        <div className="form-actions">
          <button 
            type="button" 
            className="cancel-btn" 
            onClick={onCancel}
            disabled={loading}
          >
            Cancelar
          </button>
          <button 
            type="submit" 
            className="submit-btn" 
            disabled={loading}
          >
            {loading ? 'Guardando...' : 'Guardar'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default PointOfSaleForm;
